import { getDictList } from '@/api/base'

export default {
  data() {
    return {
      dicts: {}
    }
  },
  methods: {
    async getThisDict(codeList) {
      getDictList(codeList).then(res=>{
        codeList.forEach(code=>{
          this.$set(this.dicts,code,res.data[code]);
        })
      })
    },
    onCopySuccess(){
      this.$toast("复制成功");
    },
    onCopyError(){
      this.$toast("复制失败");
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/initDict.js